export const build = { date:"2026-06-03.0916", stage:"alpha" }
